<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-10-10 09:26:28
 * @LastEditors: whaoo
 * @LastEditTime: 2024-05-20 10:44:19
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  box-sizing: border-box;
}
.container {
  width: 100%;
  background-color: #f5f7fb;
  padding: 20px;
  min-height: 100%;
}
.search_box {
  margin-bottom: 20px;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  font-size: 14px;
}
.el_input_width {
  width: 180px;
}
.el-table th.el-table__cell {
  background-color: #eeeeee;
  color: #384951;
}

.flex_space_between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex_start_center {
  display: flex;
  justify-content: start;
  align-items: center;
}
.flex_center_center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex_start {
  display: flex;
  justify-content: start;
}
.mr_12 {
  margin-right: 12px;
}
.mr_24 {
  margin-right: 24px;
}
.el_dialog .el-table th.el-table__cell {
  background-color: #eeeeee;
  color: #3889ff !important;
}

.el-dialog__header {
  padding: 16px;
  background-color: #f5f7fb;
  border-radius: 10px 10px 0 0;
}
.el-dialog__title {
  color: #252b50;
  font-weight: 700;
}
.el-dialog {
  border-radius: 10px;
}
.el-dialog__footer {
  text-align: center !important;
  padding-top: 20px;
  border-top: 1px solid #eeeeee;
}
.block {
  text-align: right;
  margin-top: 20px;
}
.el-menu {
  border-right: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue